const utils = require('../../../lib/utils')

module.exports = {
    model: {
        dataDATE: null,

        date: null,
        time: null,

        config: {
            frameLess: false, // prevents margins between input fields
            momentDataDateFormat: 'DD.MM.YYYY',
            momentDataTimeFormat: 'HH:mm',

            fields: {

                date: { // @see air-datetime-picker.js
                    // forceFirstChangePropagation: false,
                    // fieldToModelDelay: 150, // if multiple picker value changes happen (e.g., if the time picker slider is used) this is the number of milliseconds to delay the actual form-field-change. if another change occurs within that time the first one will not be propagated and the timer starts again.
                    momentDataDateFormat: '',
                    momentDateFormat: 'DD.MM.YYYY',
                    // inheritDayOnTextInput: false, // e.g., if you need a time picker which shows times and sets full timestamps and the day should not change if the user changes the value via text input one may set this value to true.
                    // selectLastNrOfCharactersOnTabFocusIn: 0, // if one likes to see and manipulate a full dataset (e.g., date and time) but usually only needs to set the time this flag my decide how many characters at the very end of the text-input should be selected if a user tabs through the form. this is a convenience feature only. e.g., set this to 5 than show DD.MM.YYYY HH:mm but auto-select only HH:mm.
                    airDatePicker: {
                        language: 'de', // this field does not exist since the picker-update to 3.4.0 but is utilized via the keys of airDatepickerLocales var.
                        dateFormat: 'dd.MM.yyyy',
                        // inline: false,
                        autoClose: true,
                        keyboardNav: false,
                        // view: 'days', // days, months, years
                        // minView: 'days', // days, months, years
                        // hoursStep: 1,
                        // minutesStep: 1,
                        // timeFormat: 'HH:mm',
                        // timepicker: true,
                        // onlyTimepicker: true,
                        // isMobile: false,
                    },
                    inputSize: 8, // size attribute of input type text
                },
                time: {
                    timeParts: ['hours', 'minutes'], // ['hours', 'minutes', 'seconds', 'milliseconds']
                    defaultDataTIME: null,
                    // hours: {
                    //     stepSize: 1,
                    // },
                    // minutes: {
                    //     stepSize: 30,
                    // },
                }
            }
        },
    },

    methods: {
        prepare: function(){
            this.prepareConfigs()
        },

        prepareConfigs: function(){
            const fieldConfig = this.model.config || {}

            if(this.model.dataDATE){
                this.model.date = utils.moment(this.model.dataDATE).format(fieldConfig.momentDataDateFormat)
                this.model.time = utils.moment(this.model.dataDATE).format(fieldConfig.momentDataTimeFormat)
            }
        },

        onChange: function(date, time, refreshGranted = true){
            const fieldConfig = this.model.config || {}
            let changeFound = false
            let tellParent = false

            if(date !== undefined && this.model.date !== date){
                if(date === null){
                    this.model.date = null
                } else {
                    this.model.date = utils.moment(date).format(fieldConfig.momentDataDateFormat)
                }
                changeFound = true
            }
            if(time !== undefined && this.model.time !== time){
                this.model.time = time
                changeFound = true
            }

            if(changeFound){
                if(this.model.time){
                    tellParent = true
                    if(this.model.date){
                        this.model.dataDATE = utils.moment(`${this.model.date} ${this.model.time}`, `${fieldConfig.momentDataDateFormat} ${fieldConfig.momentDataTimeFormat}`).format()
                    } else {
                        this.model.dataDATE = utils.moment(`${this.model.time}`, `${fieldConfig.momentDataTimeFormat}`).format()
                    }
                } else if(this.model.dataDATE !== null){
                    this.model.dataDATE = null
                    tellParent = true
                }

                if(tellParent){
                    this.parent(parentComponent => {
                        parentComponent.trigger('onChildChanged', {
                            fieldCode: this.model.fieldCode,
                            value: this.model.dataDATE
                        })
                    })
                }
            }
        },

        setDate(date){
            const fieldConfig = this.model.config || {}
            this.model.dataDATE = date

            if(this.model.dataDATE){
                this.model.date = utils.moment(this.model.dataDATE).format(fieldConfig.momentDataDateFormat)
                this.model.time = utils.moment(this.model.dataDATE).format(fieldConfig.momentDataTimeFormat)
            } else {
                this.model.date = null
                this.model.time = null
            }

            this.find('base_form_fields_air-datetime-picker', picker => {
                picker.setDate(this.model.dataDATE)
            })
            this.find('base_form_fields_time-picker', picker => {
                picker.setTime(this.model.time)
            })
        }
    },

    hooks: {
        onChildChanged: function($element, options){
            if(options.fieldCode === 'date'){
                this.onChange(options.value, undefined);
            } else if (options.fieldCode === 'time'){
                this.onChange(undefined, options.value);
            }
        }
    }
};
